<template>
  <div
    :class="{
      [ns.b()]: true,
      [ns.e('is-vertical')]: orientation === 'vertical',
    }"
  >
    <div :class="ns.e('panel')" :style="panel1Style">
      <slot name="left" />
    </div>
    <!-- 手柄样式 -->
    <div v-if="canfull" :class="ns.e('canfullStyle')">
      <lt-icon
        v-show="ratio != 0"
        :class="ns.e('rightIcon')"
        color="#fff"
        font-size="7px"
        @click="caretLeft"
        ><ArrowLeft
      /></lt-icon>
      <div :class="ns.e('rightIcon')">
        <lt-icon
          v-show="ratio != 1"
          color="#fff"
          font-size="7px"
          @click="caretRight"
          ><ArrowRight
        /></lt-icon>
      </div>
    </div>
    <div
      v-else
      ref="resizerRef"
      :style="{ flexDirection: orientation === 'vertical' ? 'row' : 'column' }"
      :class="{
        [ns.e('resizer')]: true,
        [ns.e('vertical-style')]: orientation === 'vertical',
      }"
      @mousedown="startResizing"
    >
      <div
        v-for="n in 6"
        v-show="orientation === 'vertical'"
        :key="n"
        :class="ns.e('vertical')"
      />
      <div
        v-for="n in 6"
        v-show="orientation === 'horizontal'"
        :key="n"
        class="aaa"
        :class="ns.e('horizontal')"
      />
    </div>

    <div :class="ns.e('panel')" :style="panel2Style">
      <slot name="right" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { useNamespace } from '@lit-element/hooks'
import { ArrowLeft, ArrowRight } from '@inte-cloud/icons-vue'
import { splitProps } from './split'

defineOptions({
  name: 'LtSplit',
})

const ns = useNamespace('split')
const props = defineProps(splitProps)

const isResizing = ref<boolean>(false)
const ratio = ref<number>(props.initialRatio)
const resizerRef = ref<Element | null>(null)
const panelState = ref<'initial' | 'left-full' | 'right-full'>('initial') // 添加状态记录当前展示的面板

const panel1Style = computed(() => {
  if (props.orientation === 'horizontal') {
    return { flex: ratio.value, display: ratio.value > 0 ? 'block' : 'none' }
  } else {
    return {
      flex: ratio.value,
      height: `${ratio.value * 100}%`,
      display: ratio.value > 0 ? 'block' : 'none',
    }
  }
})

const caretLeft = () => {
  if (panelState.value === 'right-full') {
    ratio.value = props.initialRatio // 还原到初始比例
    panelState.value = 'initial'
  } else if (panelState.value === 'left-full') {
    ratio.value = props.initialRatio // 还原到初始比例
    panelState.value = 'initial'
  } else {
    ratio.value = 0 // 展示左边全部面板
    panelState.value = 'left-full'
  }
}
const caretRight = () => {
  if (panelState.value === 'left-full') {
    ratio.value = props.initialRatio // 还原到初始比例
    panelState.value = 'initial'
  } else if (panelState.value === 'right-full') {
    ratio.value = props.initialRatio // 还原到初始比例
    panelState.value = 'initial'
  } else {
    ratio.value = 1 // 展示右边全部面板
    panelState.value = 'right-full'
  }
}

const panel2Style = computed(() => {
  if (props.orientation === 'horizontal') {
    return {
      flex: 1 - ratio.value,
      display: ratio.value < 1 ? 'block' : 'none',
    }
  } else {
    return {
      flex: 1 - ratio.value,
      height: `${(1 - ratio.value) * 100}%`,
      display: ratio.value < 1 ? 'block' : 'none',
    }
  }
})

const startResizing = (event: MouseEvent) => {
  isResizing.value = true
  document.addEventListener('mousemove', resize, { passive: true })
  document.addEventListener('mouseup', stopResizing, { passive: true })
}

// const resize = (event: MouseEvent) => {
//   if (isResizing.value && resizerRef.value) {
//     const { clientX, clientY } = event
//     const containerRect =
//       resizerRef.value.parentElement?.getBoundingClientRect()
//     let newRatio = 0

//     if (props.orientation === 'horizontal' && containerRect) {
//       newRatio = (clientX - containerRect.left) / containerRect.width
//     } else if (containerRect) {
//       newRatio = (clientY - containerRect.top) / containerRect.height
//     }

//     if (props.canfull) {
//       ratio.value = Math.max(0, Math.min(1, newRatio))
//     } else {
//       ratio.value = Math.max(0.1, Math.min(0.9, newRatio))
//     }
//   }
// }
const resize = (event: MouseEvent) => {
  if (isResizing.value && resizerRef.value) {
    const { clientX, clientY } = event
    const containerRect =
      resizerRef.value.parentElement?.getBoundingClientRect()
    let newRatio = 0

    if (props.orientation === 'horizontal' && containerRect) {
      newRatio = (clientX - containerRect.left) / containerRect.width
    } else if (containerRect) {
      newRatio = (clientY - containerRect.top) / containerRect.height
    }

    ratio.value = Math.max(0, Math.min(1, newRatio))
  }
}
const stopResizing = () => {
  isResizing.value = false
  document.removeEventListener('mousemove', resize)
  document.removeEventListener('mouseup', stopResizing)
}
</script>
